import { Box, Typography } from '@mui/material';
import { saasModernTheme } from 'common/theme/saasModern';
import styled, { keyframes } from 'styled-components';

export const LogoSection = styled(Box)`
  background: var(--Background-Default, #111927);
  padding: 20px 0 10px 0;
`;

export const LogoContainer = styled(Box)`
  width: 80%;
  margin: 0 auto;
  overflow: hidden;
`;

export const Title = styled(Typography)`
  text-align: center;
  font-family: ${saasModernTheme.fontFamily};
  margin-bottom: 30px;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  & strong {
    background: ${saasModernTheme.customColor.backgroundTextGradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const scrollAnimation = keyframes`
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
`;

export const LogoScroller = styled(Box)`
  display: flex;
  align-items: center;
  width: fit-content;
  animation: ${scrollAnimation} 30s linear infinite;
  gap: 30px;
  position: relative;
  left: 0;
  will-change: transform;
`;

export const LogoItem = styled(Box)`
  width: 150px;
  padding: 0 5px;
  flex-shrink: 0;
  img {
    width: auto;
    height: 60px;
  }
`;
